import { render, staticRenderFns } from "./ProductSpecialist.vue?vue&type=template&id=469e7fa5&"
import script from "./ProductSpecialist.vue?vue&type=script&lang=js&"
export * from "./ProductSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecialist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
